module.exports = __webpack_public_path__ + "img/banner-bmw-rinascente.61100c21.png";